import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRelationMany1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={142}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M8.022 9.697c0 2.373-1.497 4.667-4.496 4.962a1.121 1.121 0 1 0 .22 2.231c4.338-.426 6.517-3.87 6.519-7.192.001-3.329-2.185-6.743-6.546-7.076a1.121 1.121 0 1 0-.17 2.236c2.99.228 4.474 2.47 4.473 4.839"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M16.333 3.347a1.121 1.121 0 1 0-2.242 0v12.801a1.121 1.121 0 1 0 2.242 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M15.09 16.148v-12.8a.121.121 0 1 1 .243 0v12.8a.121.121 0 1 1-.242 0m.122-13.922c.62 0 1.121.502 1.121 1.121v12.801a1.121 1.121 0 1 1-2.242 0v-12.8c0-.62.502-1.122 1.121-1.122"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M2 9.517a1 1 0 0 1 1-1h135.5a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M131.5 3.121a1.121 1.121 0 1 0-2.243 0v12.801a1.121 1.121 0 0 0 2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M130.379 2c.619 0 1.121.502 1.121 1.121v12.801a1.121 1.121 0 1 1-2.243 0v-12.8c0-.62.502-1.122 1.122-1.122"
      clipRule="evenodd"
    />
    <path
      fill="#C2C8D3"
      d="M125.484 3.121a1.121 1.121 0 1 0-2.243 0v12.801a1.121 1.121 0 0 0 2.243 0z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M124.363 2c.619 0 1.121.502 1.121 1.121v12.801a1.121 1.121 0 1 1-2.243 0v-12.8c0-.62.502-1.122 1.122-1.122"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRelationMany1;
